import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Icon from '../AppIcon';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className={`relative inline-flex items-center h-6 w-11 rounded-full transition-smooth focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
        isDark ? 'bg-primary' : 'bg-muted'
      } ${className}`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      role="switch"
      aria-checked={isDark}
    >
      <span
        className={`inline-flex items-center justify-center h-5 w-5 rounded-full bg-background shadow-sm transition-smooth transform ${
          isDark ? 'translate-x-6' : 'translate-x-0.5'
        }`}
      >
        {isDark ? (
          <Icon name="Moon" size={12} className="text-primary" />
        ) : (
          <Icon name="Sun" size={12} className="text-secondary" />
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;